import React, {Component} from "react";
import { strings } from "../localization";
import Expander from "./Expander";

export default class CustomDropDown extends Component{
    constructor(props) {
        super(props);

        this.getSelectedItems = this.getSelectedItems.bind(this);

        this.state = {
            selectedItems: this.getSelectedItems(props.selectedItems),
        };
    }

    componentDidUpdate(prevProps){
        if(this.props.selectedItems){
            const propsItems = this.getSelectedItems(this.props.selectedItems);
            const prevPropsItems = this.getSelectedItems(prevProps.selectedItems);

            if(propsItems.join('') !== prevPropsItems.join('')){
                this.setState({selectedItems: propsItems});
            }
        }
    }

    getSelectedItems = (selectedItems) => {
        if(!selectedItems) return [];
        
        if(Array.isArray(selectedItems)) return selectedItems;
        
        return [selectedItems];
    }

    onChange = (selectedItemKey) => {
        const { onChange, multipleSelection } = this.props;

        if(multipleSelection){
            const selectedItems = this.state.selectedItems.includes(selectedItemKey) 
                                ? this.state.selectedItems.filter(n => n !== selectedItemKey)
                                : [...this.state.selectedItems, selectedItemKey];

            this.setState({selectedItems});
            onChange(selectedItems);
        }
        else{
            this.setState({selectedItems: [selectedItemKey]});
            onChange(selectedItemKey);
        }
    }

    clearSelecedItems = () => {
        this.setState({selectedItems: []});

        if(this.props.multipleSelection)
            this.props.onChange([]);
        else
            this.props.onChange('');        
    }

    createDropdownLabel = () => {

        const { items, placeholder } = this.props;

        const numberOfSelectedItems = this.state.selectedItems.length;
        
        switch (numberOfSelectedItems) {
            case 0:
                return placeholder ? placeholder : "";
            case 1:
                const item = items.find(item => item.value === this.state.selectedItems[0]);
                // RAV-6242
                // Adding more safety to resolve a crash risk (checking if "label" exists)
                if (item && item.label) {
                    return item.label;
                }
                console.warn("CustomDropDown: Selected item not found in items list");
                return; // Return undefined
            default:
                return strings.formatString(strings.custom_dropdown_x_selected, numberOfSelectedItems);
        }
    }

    renderOptions = () => {
        const options = [];
        
        const { items, multipleSelection } = this.props;

        items.forEach(item => {
            const isSelected = this.state.selectedItems.includes(item.value);
            
            options.push(
                <div
                    key={item.value}
                    className={`custom-dropdown-item ${isSelected ? 'selected' : ''}`}
                    onClick={() => {
                        this.onChange(item.value);
                    }}
                >
                    {multipleSelection && <i className="material-icons">{isSelected ? 'check_box' : 'check_box_outline_blank'}</i>}
                    {item.label}
                </div>
            );
        });

        return options;
    }

    render() {

        const className = `custom-dropdown ${this.props.className} ${this.props.disabled ? 'disabled' : ''}`;

        return (
            <Expander
                className={className}
                label={this.createDropdownLabel()}
                showClearButton={this.state.selectedItems.length > 0 && !this.props.required}
                showPlaceholder={this.state.selectedItems.length === 0}
                onClear={this.clearSelecedItems}
                {...this.props}
            >
                {this.renderOptions()}
            </Expander>
        );
    }
    
}